import type { SVGProps } from 'react';

const SvgShoppingHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M18.53 4.12v5.6a.75.75 0 0 0 .75.75h6.39V9H20V4.12Z" />
      <path d="M16.54 18.81a9.2 9.2 0 0 0 2.5.4h.24a9.5 9.5 0 0 0 6.88-16 9.49 9.49 0 0 0-13.85 13h-1.78v1.5h3.66a.74.74 0 0 0 .75-.75v-3.73h-1.5v1.94a8 8 0 1 1 5.64 2.54 8.3 8.3 0 0 1-2.08-.33Z" />
      <path d="m30.29 20.17 1.32-10-1.48-.2L28.8 20a1.21 1.21 0 0 1-1.2 1H9.28L8 9.09a4.45 4.45 0 0 0-4.45-3.94H.64v1.5h2.91a3 3 0 0 1 2.93 2.61L8 22.68a4.92 4.92 0 0 0 2.43 3.63 3.1 3.1 0 0 0-1 2.31A3.16 3.16 0 1 0 15.19 27h9.2a3.15 3.15 0 1 0 2.68-1.52H12.84a3.45 3.45 0 0 1-3.4-2.95H27.6a2.73 2.73 0 0 0 2.69-2.36M12.51 30.28a1.66 1.66 0 1 1 1.65-1.66 1.66 1.66 0 0 1-1.65 1.66m16.22-1.66a1.66 1.66 0 1 1-3.31 0A1.65 1.65 0 0 1 26.93 27h.15a1.67 1.67 0 0 1 1.65 1.62" />
    </g>
  </svg>
);

export default SvgShoppingHistory;
